import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Navigate } from "react-router-dom";

export default class AddSocialMedia extends Component {
  state = {
    icon: null, // file
    url: "",
    message: "",
    notification: false,
    redirect: false,
    loading: false,
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.state.icon) {
      this.setState({
        notification: true,
        message: "Please select an icon image.",
      });
      setTimeout(() => {
        this.setState({ notification: false, message: "" });
      }, 3000);
      return;
    }

    if (!this.state.url) {
      this.setState({
        notification: true,
        message: "Please enter a URL.",
      });
      setTimeout(() => {
        this.setState({ notification: false, message: "" });
      }, 3000);
      return;
    }

    if (init() !== "success") {
      return this.setState({ redirect: true });
    }

    this.setState({ loading: true });

    const fd = new FormData();
    // field names should match your backend (schema was icon + url)
    fd.append("icon", this.state.icon);
    fd.append("url", this.state.url);

    axios
      .post(Constants.postUrls.addSocialMedia, fd)
      .then((resp) => {
        this.setState({
          notification: true,
          message: resp.data?.message || "Social media link created successfully",
          loading: false,
        });
        setTimeout(() => {
          this.setState({ notification: false, message: "", redirect: true });
        }, 3000);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          message: err?.response?.data?.message || "Error creating social media link",
          loading: false,
        });
        setTimeout(() => {
          this.setState({ notification: false, message: "" });
        }, 5000);
      });
  };

  render() {
    if (this.state.redirect === true) {
      // change '/socialmedia' to your listing route if different
      return <Navigate to="/socialmedia" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Add Social Media
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      type="file"
                      label="Social Media Icon"
                      name="icon"
                      fullWidth
                      focused
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) =>
                        this.setState({
                          icon: e.target.files[0] || null,
                        })
                      }
                      style={{ width: "100%", height: "100%" }}
                    />
                  </Grid>

                  <Grid item sm={6} xs={12}>
                    <TextField
                      type="url"
                      label="Social Media URL"
                      name="url"
                      fullWidth
                      required
                      value={this.state.url}
                      onChange={this.handleInput}
                      placeholder="https://facebook.com/yourpage"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </Grid>
                </Grid>

                <Grid align="left" mt={2}>
                  <MDButton variant="contained" size="small" color="info" type="submit">
                    {this.state.loading ? "Creating..." : "Create"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color="success"
              icon="notifications"
              title="VASA | Social Media"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
